import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { useFirestore } from '../../hooks/useFirestore';
import { Loan } from '../../schema';
import { CombinedFullAppWebhookResult } from '../../utils/lendAPIPrequalHelper';
import LendAPISuccessPage from '../../loan/components/LendAPISuccessPage';
import PreQualFunnelLayout from '../PreQualFunnelLayout';
import LendAPIFunnelHeaderRight from '../../shared/components/LendAPIFunnelHeaderRight';

function buildWebhookResult(loan: Loan): CombinedFullAppWebhookResult | null {
  if (loan.autoRequestedDocs && loan.autoRequestedDocs.length > 0 && loan.docUploadUrl) {
    return {
      autoRequestedDocs: loan.autoRequestedDocs,
      docUploadUrl: loan.docUploadUrl,
    };
  }
  return null;
}

const LendAPICombinedSuccess: React.FC = () => {
  const { loanId } = useParams<{ loanId: string }>();
  const firestore = useFirestore();
  const [webhookResult, setWebhookResult] = useState<CombinedFullAppWebhookResult | null>(null);
  const [source, setSource] = useState<number | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!loanId) {
      setLoading(false);
      return;
    }

    firestore
      .collection('loans')
      .doc(loanId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const loan = doc.data() as Loan;
          setWebhookResult(buildWebhookResult(loan));
          setSource(loan.source);
        }
      })
      .catch((error) => {
        console.error('[LendAPICombinedSuccess] Error fetching loan:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [firestore, loanId]);

  return (
    <PreQualFunnelLayout headerRight={<LendAPIFunnelHeaderRight />} className="myAppsLayout">
      {loading ? (
        <Spin size="large" style={{ marginTop: '2rem', display: 'block' }} />
      ) : (
        <LendAPISuccessPage webhookResult={webhookResult} source={source} />
      )}
    </PreQualFunnelLayout>
  );
};

export default LendAPICombinedSuccess;
